import {
  CompletePaymentProps,
  IPaymentService,
  PaymentResponse,
  PrintReceiptProps,
  SubmitPaymentProps
} from '../../payment.type';
import { localPrinter } from '../../../printer/local/local-printer.service';

/**
 * "Local device": no connector. Receipts go to a printer on this till over
 * Web Serial, and the cash drawer hangs off that printer.
 *
 * There is no card terminal in this mode. The Card button is hidden when this
 * device is selected, and a card payment that reaches here anyway is declined
 * rather than approved without a terminal. Cash and Manual Card complete.
 */
export const LocalPaymentService = (): IPaymentService => {
  const submitPayment = async (
    props: SubmitPaymentProps
  ): Promise<PaymentResponse> => {
    if (props.paymentType === 'Card') {
      // eslint-disable-next-line
      console.warn('Local device - card payment declined: no terminal.');
      return { isSuccessful: false };
    }
    return { isSuccessful: true };
  };

  const completePayment = async (props: CompletePaymentProps) => {
    await localPrinter.printSale(props.salesResponse, { shop: props.shop });
  };

  const printLastReceipt = async (props: PrintReceiptProps) => {
    if (!props.salesResponse) {
      // eslint-disable-next-line
      console.error('No receipt in store.');
      return;
    }
    await localPrinter.printSale(props.salesResponse, {
      shop: props.shop,
      isCopy: props.isCopy,
      openDrawer: false
    });
  };

  // Called before the sale is created. Refusing here means a till with no
  // printer never takes a sale it cannot print.
  const wakeUp = () => localPrinter.ensureReady();

  return {
    submitPayment,
    completePayment,
    printLastReceipt,
    wakeUp
  };
};
